import useTranslations from "@/shared/lang/useTranslations";

import type { OtcFees } from "../../types/cryptoSwaps.types";
import { amountPrecision, visibleFees, type PairPrecision } from "../../utils/cryptoSwapFormat";
import { AssetAmount } from "./AssetAmount";

export interface FeesValueProps {
  fees: OtcFees;
  pair?: PairPrecision | null;
}

/** A fee that rounds to zero at display precision reads as "included in the price", never as "0 COP". */
export function FeesValue({ fees, pair }: FeesValueProps) {
  const { t } = useTranslations("cryptoSwaps");
  const shown = visibleFees(fees, (currency) => amountPrecision(currency, pair));
  if (shown.length === 0) return <>{t("fees_included")}</>;

  return (
    <span className="inline-flex flex-col items-end gap-0.5 font-mono tabular-nums">
      {shown.map((fee) => (
        <span key={fee.currency}>
          <AssetAmount
            value={fee.total}
            currency={fee.currency}
            pair={pair}
            className="text-[length:inherit] font-normal"
          />{" "}
          {fee.currency}
        </span>
      ))}
    </span>
  );
}
